import { Box } from '@mui/material';
import data, { Skin } from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

interface EmojiPickerProps {
    onSelectEmoji: (emoji: Skin) => void;
}

export default function EmojiPicker({ onSelectEmoji }: EmojiPickerProps) {
    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: '60px',
                right: '10px',
                zIndex: 99999,
            }}>
            <Picker data={data} onEmojiSelect={onSelectEmoji} theme="light" previewPosition="none" />
        </Box>
    );
}
